/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface DeleteOrganizationPaymentCancelResponse
 */
export interface DeleteOrganizationPaymentCancelResponse {
  /**
   *
   * @type {number}
   * @memberof DeleteOrganizationPaymentCancelResponse
   */
  status: number
}

export function DeleteOrganizationPaymentCancelResponseFromJSON(json: any): DeleteOrganizationPaymentCancelResponse {
  return DeleteOrganizationPaymentCancelResponseFromJSONTyped(json, false)
}

export function DeleteOrganizationPaymentCancelResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DeleteOrganizationPaymentCancelResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: json['status']
  }
}

export function DeleteOrganizationPaymentCancelResponseToJSON(
  value?: DeleteOrganizationPaymentCancelResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status
  }
}
